import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { ref } from "vue";
  import { useRouter } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  let tip = ref("");
  let status = ref("404");
  let isNoFound = ref(false);
  const router = useRouter();
  const checkRouter = () => {
    //判断路由树是否存在首页存在即认为有路由权限
    let homePermission = router.getRoutes().find((el) => el.name === "admin/home" || el.name === "app/index");
    if (homePermission) {
      isNoFound.value = true;
      tip.value = "找不到页面，请确认地址是否正确。";
      status.value = "404";
    } else {
      status.value = "403";
      tip.value = "无访问权限，请联系管理员。";
      isNoFound.value = false;
    }
  };
  const back = () => {
    // warning： Go to the node that has the permission
    router.replace({ path: "/home" });
  };
  checkRouter();

return (_ctx: any,_cache: any) => {
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_result, {
      class: "result",
      status: _unref(status),
      subtitle: _unref(tip)
    }, null, 8, ["status", "subtitle"]),
    _withDirectives(_createVNode(_component_a_button, {
      type: "primary",
      onClick: back
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("返回首页")
      ])),
      _: 1
    }, 512), [
      [_vShow, _unref(isNoFound)]
    ])
  ]))
}
}

})